import { isBefore, isValid } from 'date-fns'
import { useState } from 'react'

import * as S from '../DatePicker.styles'
import { DateInputsProps } from '../DatePicker.types'
import { formatDateToString, parseStringToDate } from '../DatePicker.utils'

const dateFormat = 'MM/dd/yyyy'
const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]

export const DateInputs = ({ value, allowOpenRange, onChange }: DateInputsProps) => {
  const [startDate, setStartDate] = useState(() =>
    formatDateToString(value?.startDate, { format: dateFormat }),
  )
  const [endDate, setEndDate] = useState(() =>
    formatDateToString(value?.endDate, { format: dateFormat }),
  )

  const triggerOnChange = (startDate: string, endDate: string) => {
    if (!startDate && !endDate) return onChange(undefined)

    const parsedStartDate = parseStringToDate(startDate, { format: dateFormat })
    const parsedEndDate = parseStringToDate(endDate, { format: dateFormat })
    const hasValidStart = isValid(parsedStartDate)
    const hasValidEnd = isValid(parsedEndDate)

    if (hasValidStart && hasValidEnd) {
      if (isBefore(parsedStartDate, parsedEndDate)) {
        onChange({ startDate: parsedStartDate, endDate: parsedEndDate })
      }
      return
    }

    if (!allowOpenRange) return

    if (hasValidStart) return onChange({ startDate: parsedStartDate })
    if (hasValidEnd) return onChange({ endDate: parsedEndDate })
  }

  const handleChangeStartDate = (value: string) => {
    setStartDate(value)
    triggerOnChange(value, endDate)
  }

  const handleChangeEndDate = (value: string) => {
    setEndDate(value)
    triggerOnChange(startDate, value)
  }

  return (
    <S.InputsContainer>
      <S.DateInput
        type="text"
        id="date-inputs-from"
        placeholder="MM/DD/YYYY"
        mask={dateMask}
        value={startDate}
        onChange={event => handleChangeStartDate(event.target.value)}
      />
      <S.DateInput
        type="text"
        id="date-inputs-to"
        placeholder="MM/DD/YYYY"
        mask={dateMask}
        value={endDate}
        onChange={event => handleChangeEndDate(event.target.value)}
      />
    </S.InputsContainer>
  )
}
